import clsx from 'clsx';
import { colors } from '../foundation';
import ChevronLeft from '../svg/ChevronLeft';
import ChevronRight from '../svg/ChevronRight';

type Props = {
  pages: number;
  currentPage: number;
  onClick: (page: number) => void;
  navigation: 'next' | 'prev';
  inverse: boolean;
  disabled: boolean;
};

const NavigationButton = ({ pages, currentPage, onClick, navigation, inverse, disabled }: Props) => {
  const handlePageClick = (currentPage: number, pages: number) => {
    if (navigation === 'next' && currentPage < pages) {
      onClick(currentPage + 1);
    } else if (navigation === 'prev' && currentPage > 1) {
      onClick(currentPage - 1);
    }
  };

  return (
    <button
      aria-label={navigation === 'next' ? 'Next page' : 'Prevoius page'}
      aria-disabled={disabled}
      className={`flex h-[36px] w-[36px] items-center justify-center ${clsx({
        'pointer-events-none opacity-30': disabled,
      })}`}
      onClick={() => handlePageClick(currentPage, pages)}
    >
      {navigation === 'prev' && <ChevronLeft color={inverse ? colors.monochrome.inverse[6] : colors.monochrome[6]} />}
      {navigation === 'next' && <ChevronRight color={inverse ? colors.monochrome.inverse[6] : colors.monochrome[6]} />}
    </button>
  );
};
export default NavigationButton;
